import { graphql } from "../generated";

export const GetCall = graphql(
  `
    query GetCall($callId: ID!, $skipSentiments: Boolean!, $skipPredictedCsat: Boolean!) {
      getCall(callId: $callId) {
        ...CallDetails
      }
    }
  `
);
